import { useState, useEffect } from 'react'
import { statusIncomeCertificateActiveAPI } from '../services/income/certficate'

function UseAllCertificateActive() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await statusIncomeCertificateActiveAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d) => {
          return { value: d?.active, label: d?.activeName }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])
  return data
}

export default UseAllCertificateActive
